import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../../components/CustomButton'
import { ArrowRepeat } from 'react-bootstrap-icons'
import { useState } from 'react'
import { format, startOfDay, subDays } from 'date-fns'
import ReclamacoesService from '../../../services/database/ReclamacoesService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { useJobs } from '../../../hooks/useJobs'
import Swal from 'sweetalert2'

export function ModalSincronizar({ isOpen, onClose }) {
  const [isSyncLoading, setIsSyncLoading] = useState(false)
  const [date, setDate] = useState({
    from: format(subDays(startOfDay(new Date()), 10), 'yyyy-MM-dd'),
    to: format(startOfDay(new Date()), 'yyyy-MM-dd'),
  })
  const { start } = useJobs()

  async function handleSyncReclamacoes() {
    try {
      setIsSyncLoading(true)

      const { jobId } = await ReclamacoesService.sync({
        from: date.from,
        to: date.to,
      })

      start({
        alias: 'claims-sync',
        jobId,
        label: 'Sincronização de Reclamações',
        onSuccess: async () =>
          await Swal.fire({
            title: 'Sucesso',
            text: 'A sincronização foi finalizada',
            icon: 'success',
          }),
        onError: async () =>
          await Swal.fire({
            title: 'Erro',
            text: 'Não foi possível concluir a sincronização',
            icon: 'error',
          }),
      })

      Swal.fire({
        title: 'Aviso',
        text: 'O processo está rodando em background, você será avisado quando a operação finalizar.',
        icon: 'info',
      })

      onClose()
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível iniciar a sincronização!',
        true,
      )
    } finally {
      setIsSyncLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
      centered
    >
      <Modal.Header>
        <Modal.Title>Sincronização</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col>
            <Form.Label>De</Form.Label>
            <Form.Control
              type="date"
              value={date.from}
              onChange={(e) =>
                setDate((prevState) => ({
                  ...prevState,
                  from: e.target.value,
                }))
              }
            />
          </Col>

          <Col>
            <Form.Label>Até</Form.Label>
            <Form.Control
              type="date"
              value={date.to}
              onChange={(e) =>
                setDate((prevState) => ({
                  ...prevState,
                  to: e.target.value,
                }))
              }
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          color="#3f0cc5"
          title="Sincronizar"
          isDisabled={!date.from || !date.to}
          isLoading={isSyncLoading}
          isLoadingText="Sincronizando, aguarde..."
          onClick={handleSyncReclamacoes}
        >
          <ArrowRepeat />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
